import { createFileRoute } from "@tanstack/react-router";
import AdminPitchDecks from "@/pages/AdminPitchDecks";

export const Route = createFileRoute("/admin/pitch-decks/$startupId/")({
  component: AdminPitchDecks,
});
